
export type Rights =
    | "CheckMap"
    | "CheckPlan"
    | "CheckReport"
    | "CheckDashboard"
    | "CheckGuide"
    | "AdminRights"

export const RightsArray: Rights[] = [
    "CheckMap",
    "CheckPlan",
    "CheckReport",
    "CheckDashboard",
    "AdminRights",
    "CheckGuide"
]